class babCart {
  constructor() {
    this.selectors = {
      megaMenu: '.top-level-links-wrapper',
      headerSearch: '.header-search-bar-wrapper',
      headerSearchMobile: '.mega-menu-wrapper .search-mobile',
      babNav: '.bab-nav',
      babCart: '.bab-cart',
      babCartItems: '.bab-cart .items-wrapper .items',
      babCartOverlay: '.bab-cart-overlay',
      babQuantity: '.quantity-wrapper .quantity',
      babRemoveButton: '.bab-cart .remove-item',
      babTotalPrice: '[data-bab-total]',
      babTotalSaving: '[data-bab-saving]',
      babTotalSecondPrice: '[data-bab-second-total]',
      babTotalSecondSaving: '[data-bab-second-saving]',
      babTotalThirdPrice: '[data-bab-third-total]',
      babTotalThirdSaving: '[data-bab-third-saving]',
      babAddToCart: '[data-add-bab-to-cart]',
      babFrequency: '[data-bab-frequency]',
      babBreakdownInfo: '[data-bab-breakdown-info]',
      toggleBabCart: '[toggle-bab-cart]',
      toggleBabInfo: '[toggle-bab-info]',
      babQuantitySelectorPlus: '[data-bab-quantity] .plus',
      babQuantitySelectorMinus: '[data-bab-quantity] .minus',
    };

    this.hideHeader();
    this.toggleBabBreakdownInfo();
    this.toggleBabSideCart();
    this.loadBabCartItems();
    this.addBabToCart();
    this.calculateBabPricing();

    document.body.addEventListener('click', this.handleEvent.bind(this));

    window.addEventListener('bab_updated', () => {
      this.loadBabCartItems().then(() => {
        this.calculateBabPricing();
        this.openBabSideCart();
      });
    });
  }

  handleEvent(e) {
    this.quantityButtons(e);
    this.removeCartItem(e);
  }

  hideHeader() {
    if(window.QF.has_had_subscription === false) {
      if (window.template === 'page.build-a-box') {
        const babQualifyOffer = localStorage.getItem('babQualifyOffer');
        if (babQualifyOffer === 'true') {
          document.querySelector(this.selectors.megaMenu).classList.add('hidden');
          document.querySelector(this.selectors.headerSearch).classList.add('hidden');
          document.querySelector(this.selectors.headerSearchMobile).classList.add('hidden');
          document.querySelector(this.selectors.babNav).classList.add('enhanced-offer-active');
        }
      }
    }
  }

  openBabSideCart() {
    document.querySelector(this.selectors.babNav).classList.toggle('open');
    document.querySelector(this.selectors.babCart).classList.toggle('open');
    document.querySelector(this.selectors.babCartOverlay).classList.toggle('show');
  }

  toggleBabBreakdownInfo() {
    const babBreakdownInfos = document.querySelectorAll(this.selectors.babBreakdownInfo);

    babBreakdownInfos.forEach((babBreakdownInfo) => {
      document.querySelectorAll(this.selectors.toggleBabInfo).forEach((el) => {
        el.addEventListener('click', () => {
          babBreakdownInfo.classList.toggle('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      const toggleBabInfo = document.querySelectorAll(this.selectors.toggleBabInfo);
      const isToggleBabInfoClick = Array.from(toggleBabInfo).some((el) => el.contains(event.target));

      babBreakdownInfos.forEach((babBreakdownInfo) => {
        if (!babBreakdownInfo.contains(event.target) && !isToggleBabInfoClick && !event.target.classList.contains("open")) {
          babBreakdownInfo.classList.remove("open");
        }
      });
    });
  }

  toggleBabSideCart() {
    const toggleBabCart = document.querySelectorAll(this.selectors.toggleBabCart);

    toggleBabCart.forEach((el) => {
      el.addEventListener('click', () => {
        this.openBabSideCart();
      });
    });

    document.addEventListener('click', (event) => {
      const babCart = document.querySelector(this.selectors.babCart);
      if (babCart) {
        const isOpen = babCart.classList.contains("open");
        const isToggleBabCartClick = Array.from(toggleBabCart).some((el) => el.contains(event.target));
        const isOpenClass = event.target.classList.contains("open");

        if (isOpen && !isToggleBabCartClick && !isOpenClass && !babCart.contains(event.target) && !event.target.classList.contains("minus") && !event.target.classList.contains("remove-item")) {
          this.openBabSideCart();
        }
      }
    });
  }

  async loadBabCartItems() {
    const babData = JSON.parse(localStorage.getItem('build-a-box')) || {};
    if (babData.length > 0) {
      const babCartItems = document.querySelector(this.selectors.babCartItems);
      if (babCartItems) {
        babCartItems.innerHTML = '';
        try {
          const fetchPromises = babData.map(async (item) => {
            const response = await fetch(`/products/${item.handle}?variant=${item.variant}&quantity=${item.quantity}&view=card&section_id=fg-bab-cart-item`);
            if (response.ok) {
              const productCard = await response.text();
              babCartItems.innerHTML += productCard;
            }
          });

          await Promise.all(fetchPromises);

          const wasPriceElements = babCartItems.querySelectorAll('.was-price');
          const nowPriceElements = babCartItems.querySelectorAll('.now-price');

          wasPriceElements.forEach((wasPriceElement, index) => {
            const wasPrice = parseFloat(wasPriceElement.textContent.replace(/[^0-9.-]+/g, ''));
            const nowPriceElement = nowPriceElements[index];

            if (wasPrice && nowPriceElement) {
              let firstBoxDiscount = '';
              if(window.QF.has_had_subscription === false) {
                const babQualifyOffer = localStorage.getItem('babQualifyOffer');
                if (babQualifyOffer === 'true') {
                  firstBoxDiscount = window.QF.buildABox.firstBoxDiscount;
                  const result = wasPrice * firstBoxDiscount;
                  nowPriceElement.innerHTML = '£' + (result * 1).toFixed(2);
                }
              }
            }
          });
        } catch (error) {
          console.error(error);
        }
      }
    } else {
      if (document.querySelector(this.selectors.babCartItems)) {
        document.querySelector(this.selectors.babCartItems).innerHTML = `<p class="message">Your box is empty</p>`;
      }
    }
  }

  calculateBabPricing() {
    let firstBoxDiscount = window.QF.buildABox.firstBoxDiscount;
    let secondBoxDiscount = window.QF.buildABox.secondBoxDiscount;
    let thirdBoxDiscount = window.QF.buildABox.thirdBoxDiscount;
    const babQualifyOffer = localStorage.getItem('babQualifyOffer');

    if(window.QF.has_had_subscription === false) {
      if (babQualifyOffer === 'true') {
        firstBoxDiscount = window.QF.buildABox.firstBoxDiscount;
        secondBoxDiscount = window.QF.buildABox.secondBoxDiscount;
        thirdBoxDiscount = window.QF.buildABox.thirdBoxDiscount;
      } else {
        firstBoxDiscount = 0.9;
        secondBoxDiscount = 0.9;
        thirdBoxDiscount = 0.9;
      }
    } else {
      firstBoxDiscount = 0.9;
      secondBoxDiscount = 0.9;
      thirdBoxDiscount = 0.9;
    }

    const babData = JSON.parse(localStorage.getItem('build-a-box')) || {};

    if (Array.isArray(babData)) {
      if (babQualifyOffer === 'true') {
        totalFirstPrice = babData.reduce((acc, item) => acc + (item.quantity * item.compare_at_price), 0) * firstBoxDiscount;
        comparePrice = babData.reduce((acc, item) => acc + (item.quantity * item.compare_at_price), 0);
      } else {
        totalFirstPrice = babData.reduce((acc, item) => acc + (item.quantity * item.price), 0);
        comparePrice = babData.reduce((acc, item) => acc + (item.quantity * item.price), 0) * firstBoxDiscount;
      }
      totalSecondPrice = babData.reduce((acc, item) => acc + (item.quantity * item.compare_at_price), 0) * secondBoxDiscount;
      totalThirdPrice = babData.reduce((acc, item) => acc + (item.quantity * item.compare_at_price), 0) * thirdBoxDiscount;
    } else {
      totalFirstPrice = 0;
      totalSecondPrice = 0;
      totalThirdPrice = 0;
      comparePrice = 0;
    }

    let totalFirstSaving = (totalFirstPrice - comparePrice);
    if (babQualifyOffer === 'true') {
      totalFirstSaving = (comparePrice - totalFirstPrice);
    }
    const totalSecondSaving = (comparePrice - totalSecondPrice);
    const totalThirdSaving = comparePrice - totalThirdPrice;
    let totalQuantity = 0;
    if (Array.isArray(babData)) {
      totalQuantity = babData.reduce((acc, item) => acc + item.quantity, 0);
    } else {
      totalQuantity = 0;
    }

    document.querySelectorAll(this.selectors.babTotalPrice).forEach(
      (el) => (el.innerHTML = `£${totalFirstPrice.toFixed(2)}`)
    );
    document.querySelectorAll(this.selectors.babTotalSaving).forEach(
      (el) => (el.innerHTML = totalFirstSaving ? `£${totalFirstSaving.toFixed(2)}` : "£0.00")
    );
    document.querySelectorAll(this.selectors.babTotalSecondPrice).forEach(
      (el) => (el.innerHTML = `£${totalSecondPrice.toFixed(2)}`)
    );
    document.querySelectorAll(this.selectors.babTotalSecondSaving).forEach(
      (el) => (el.innerHTML = totalSecondSaving ? `£${totalSecondSaving.toFixed(2)}` : "£0.00")
    );
    document.querySelectorAll(this.selectors.babTotalThirdPrice).forEach(
      (el) => (el.innerHTML = `£${totalThirdPrice.toFixed(2)}`)
    );
    document.querySelectorAll(this.selectors.babTotalThirdSaving).forEach(
      (el) => (el.innerHTML = totalThirdSaving ? `£${totalThirdSaving.toFixed(2)}` : "£0.00")
    );

    if(document.querySelector('[data-bab-count]')) {
      document.querySelector('[data-bab-count]').innerHTML = totalQuantity;
    }
  }

  moveBabItemsToCart() {
    const babData = JSON.parse(localStorage.getItem('build-a-box')) || [];
    const babFrequency = document.querySelector(this.selectors.babFrequency);
    const selectedValue = babFrequency.options[babFrequency.selectedIndex].value;

    // get the options index
    const selectedIndex = Array.from(babFrequency.options).findIndex(option => option.value === selectedValue);

    if (babData.length > 0) {
      // add variants to cart with lineItem property
      const lineItems = babData.reduce((acc, item) => {
        const properties = {};
        if(window.QF.has_had_subscription === false) {
          const babQualifyOffer = localStorage.getItem('babQualifyOffer');
          if (babQualifyOffer === 'true') {
            properties._promo_discount = 'build-a-box';
          }
        }
        properties._selling_plan = item.selling_plan[selectedIndex];
        // Include compare_at_price if available from localStorage payload
        if (item.compare_at_price) {
          const parsed = parseFloat(item.compare_at_price);
          if (!isNaN(parsed)) properties._compare_at_price = parsed.toFixed(2);
        }
        acc.items.push({
          id: item.variant,
          quantity: item.quantity,
          properties,
          selling_plan: item.selling_plan[selectedIndex],
        });
        return acc;
      }, { items: [] });

      // console.log('lineItems:', lineItems);
      window.cart.add(lineItems).then(() => {
        this.calculateBabPricing();
      });
      document.querySelector(this.selectors.babCartItems).innerHTML = `<p class="message">Your box has been added to your cart.</p>`;
      localStorage.removeItem('build-a-box');
    }
  }

  addBabToCart() {
    document.querySelectorAll(this.selectors.babAddToCart).forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        this.moveBabItemsToCart();
      });
    });
  }

  quantityButtons(e) {
    const babData = JSON.parse(localStorage.getItem('build-a-box')) || {};

    // Convert babData object to an array
    const babDataArray = Object.values(babData);

    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.babQuantitySelectorPlus);
    if (quantityPlus) {
      const quantity = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantity.getAttribute("data-stock");
      const variant_id = parseInt(quantity.getAttribute("data-variant-id"));

      if (stock > 1) {
        // Find the index of the item in babDataArray based on variant
        const itemIndex = babDataArray.findIndex(item => {
          return item.variant === variant_id;
        });

        // Update the quantity of the item
        if (itemIndex !== -1) {
          quantity.innerHTML = parseInt(quantity.innerHTML) + 1;
          babDataArray[itemIndex].quantity++;
        }

        // Update localStorage with the updated babData
        localStorage.setItem('build-a-box', JSON.stringify(babDataArray));

        this.calculateBabPricing();
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.babQuantitySelectorMinus);
    if (quantityMinus) {
      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_id = parseInt(quantity.getAttribute("data-variant-id"));

      if (current > 0) {
        // Find the index of the item in babDataArray based on variant
        const itemIndex = babDataArray.findIndex(item => {
          return item.variant === variant_id;
        });

        // Update the quantity of the item
        if (itemIndex !== -1) {
          quantity.innerHTML = parseInt(quantity.innerHTML) - 1;
          babDataArray[itemIndex].quantity--;

          // Check if the quantity has reached 0, and remove the item from the cart if it has
          if (babDataArray[itemIndex].quantity === 0) {
            babDataArray.splice(itemIndex, 1);
            e.target.closest('#shopify-section-fg-bab-cart-item').remove();
          }
        }

        // Update localStorage with the updated babData
        localStorage.setItem('build-a-box', JSON.stringify(babDataArray));

        if (babDataArray.length === 0) {
          document.querySelector(this.selectors.babCartItems).innerHTML = `<p class="message">Your box is empty</p>`;
        }

        this.calculateBabPricing();
      }
    }
  }

  // create a function to remove an item from passport local storage
  removeCartItem(e) {
    const removeButton = e.target.closest(this.selectors.babRemoveButton);
    if (removeButton) {
      const variant_id = removeButton.getAttribute("data-variant-id");
      // remove the item from the local storage
      const babData = JSON.parse(localStorage.getItem('build-a-box')) || [];
      const itemIndex = babData.findIndex(item => item.variant === parseInt(variant_id));
      if (itemIndex !== -1) {
        babData.splice(itemIndex, 1);
        localStorage.setItem('build-a-box', JSON.stringify(babData));
        e.target.closest('#shopify-section-fg-bab-cart-item').remove();
      }
      if (babData.length === 0) {
        document.querySelector(this.selectors.babCartItems).innerHTML = `<p class="message">Your box is empty</p>`;
      }

      // this.loadBabCartItems();
      this.calculateBabPricing();
    }
  }
}

window.babCart = babCart;